import { toString } from 'lodash-es';
import { useMemo } from 'react';
import { getDeviceData } from './SyncConfigurationMerchantModal.util';
import { useDeviceManagementCapability } from '../../hooks';
import type { DashboardRowDataTypeLoader } from '../../model/merchant.model';
import { useDevicesQuery } from '../../hooks/useDevicesQuery.hook';

export interface UseSyncConfigurationMerchantModalParams {
  readonly isOpen: boolean;
  readonly merchantId?: string;
}

export function useSyncConfigurationMerchantModal({
  isOpen,
  merchantId,
}: UseSyncConfigurationMerchantModalParams): DashboardRowDataTypeLoader {
  const memorizedMerchantId = useMemo(() => toString(merchantId), [merchantId]);
  const hasDevicesPermission = useDeviceManagementCapability('logicalDevice.list');
  const shouldRequestDevicesData = isOpen && hasDevicesPermission;
  const {
    devicesData,
    isDevicesError,
    isDevicesLoading: isLoading,
  } = useDevicesQuery(memorizedMerchantId, 'merchant.id', shouldRequestDevicesData);

  return {
    ...getDeviceData(devicesData, isDevicesError, hasDevicesPermission, 'merchant.id', memorizedMerchantId),
    isLoading,
  };
}
